export const TREE_ROW_HEIGHT = 56;
export const TREE_INDENT_PX = 24;
